import { render, staticRenderFns } from "./AddMenu.vue?vue&type=template&id=0327fa10&"
import script from "./AddMenu.vue?vue&type=script&lang=js&"
export * from "./AddMenu.vue?vue&type=script&lang=js&"
import style0 from "./AddMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports